module.exports = __webpack_public_path__ + "static/media/improve_acc_eng_04.8cbf0969.png";